import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import store from '../store'

Vue.use(Vuetify)

// Load theme preference from localStorage
const savedTheme = localStorage.getItem('darkMode')
if (savedTheme !== null) {
  store.commit('toggleDarkMode', JSON.parse(savedTheme))
}

const vuetify = new Vuetify({
  theme: {
    dark: store.state.theme.isDarkMode,
    themes: {
      light: {
        primary: '#75C896',
        secondary: '#71717a',
        accent: '#7c3aed',
        error: '#ef4444',
        info: '#3b82f6',
        success: '#22c55e',
        warning: '#f59e0b',
        surface: '#fafafa',
        background: '#ffffff'
      },
      dark: {
        primary: '#75C896',
        secondary: '#a1a1aa',
        accent: '#7c3aed',
        error: '#ef4444',
        info: '#3b82f6',
        success: '#22c55e',
        warning: '#f59e0b',
        surface: '#18181b',
        background: '#27272a'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})

// Watch for theme changes and update Vuetify
store.watch(
  state => state.theme.isDarkMode,
  isDark => {
    vuetify.framework.theme.dark = isDark
    localStorage.setItem('darkMode', JSON.stringify(isDark))
  }
)

export default vuetify 